import { Routes } from '@angular/router';
import { AuthGuards, InterviewGuards } from "@bequeathed/ngx-services";
import { RecommendationsComponent } from "./features/advice/recommendations/recommendations.component";
import { CannotCompleteComponent } from "./features/interview/cannot-complete/cannot-complete.component";
import { ChatInterfaceComponent } from "./features/interview/chat-interface/chat-interface.component";
import { CompleteComponent } from "./features/interview/complete/complete.component";
import { SummaryComponent } from "./features/interview/summary/summary.component";

export const routes: Routes = [
    { path: '', redirectTo: '/interview/WILL/start', pathMatch: 'full' },
    {
        path: 'interview/:type',
        data: {
            footer: 'lite'
        },
        children: [
            {
                path: 'start',
                component: ChatInterfaceComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id/edit',
                component: ChatInterfaceComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id',
                component: ChatInterfaceComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id/:sessionId/summary',
                component: SummaryComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id/recommendations',
                component: RecommendationsComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id/complete',
                component: CompleteComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess,
                    InterviewGuards.checkWillAndAdviceCompletion
                ]
            },
            {
                path: ':id/cannot-complete',
                component: CannotCompleteComponent,
                canActivate: [
                    AuthGuards.isLoggedIn,
                    InterviewGuards.checkAccess
                ]
            },
        ]
    },
    // {
    //     path: 'another-way-to-do-good',
    //     component: CharityGivingComponent
    // },
    // {
    //     path: 'another-way-to-do-good/:charity',
    //     component: CharityGivingComponent,
    // },
    {
        path: '**',
        redirectTo: ''
    }
];
